//core here
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, RequestOptions } from '@angular/http';
import { DefaultRequestOptions } from './common/services/DefaultRequestOptions';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ModalModule } from 'ngx-bootstrap';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { CustomFormsModule } from 'ng2-validation';
import { AngularFireModule } from 'angularfire2';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

// import { AngularFireDatabaseModule } from 'angularfire2/database';
// import { AngularFireAuthModule } from 'angularfire2/auth';
// evironment
//routing here
import { AppAdminRoutingModule } from './app-admin.routes';

import { reducer } from './common/reducers';
import { AuthEffects } from './common/effects/user';
//component here
import { AppAdminComponent } from './app-admin.component';
// import { ForgotPasswordComponent } from './pages/admin/auth/forgot-password.component';
//module here
import { LayoutModule } from './layout/layout.module';
import { AuthenticateModule } from './pages/admin/auth/authenticate.module';

import { EvsProModule } from './pages/admin/evs/evs_pro.module';
import { EVSModule } from './pages/admin/evs/EVSModule';
// Anph 02/10/2017 import module QR Code
import { BatchstampModule } from './pages/admin/qrcode/batchstamp/batchstamp.module';
import { CustomerModule } from './pages/admin/qrcode/customer/customer.module';
import { StatisticModule } from './pages/admin/qrcode/statistic/statistic.module';
import { WidthdrawalModule } from './pages/admin/qrcode/widthdrawal/widthdrawal.module';
import { DistributionModule } from './pages/admin/qrcode/distribution/distribution.module';
import { OrderModule } from './pages/admin/qrcode/order/order.module';
import { NotificationsModule } from './pages/admin/qrcode/notifications/notifications.module';

//service here
import { AuthGuard } from './common/services/Auth.guard';
import { ApiService } from './common/services/Api.service';
import { ApiIcheckService } from './common/services/ApiIcheck.service';
import { AuthenticateService } from './common/services/Authenticate.service';
import { ConfirmPhoneGuard } from './confirm-phone.guard';
import { PagerService } from './common/services/Pagination.service';
import { CategoryService } from './common/services/Category.service';
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { StaticModule } from './pages/admin/qrcode/static_stamp/static.module';
import { GiftModule } from './pages/admin/qrcode/gift/gift.module';
import { ExchangeModule } from './pages/admin/qrcode/exchange_gift/exchange.module';
import { StaticReportModule } from './pages/admin/qrcode/static_report/static_report.module';
import { Distribution2Module } from './pages/admin/qrcode/distribution-2/distribution-2.module';
import { BoxRetalStampsModule } from './pages/admin/qrcode/share/boxRetalStamps/boxRetalStamps.module';
import { RequestBoxModule } from './pages/admin/qrcode/requestBox/requestBox.module';
import { RequestBoxSendModule } from './pages/admin/qrcode/requestBoxSend/requestBoxSend.module';
import { ProductRoadmapModule } from './pages/admin/qrcode/productRoadmap/productRoadmap.module';
import { ForgotPassBusinessService } from './common/services/ForgotPassBusiness.service';
import { StampListMbModule } from './pages/admin/evs/stamp_list_mb/stamp-mb.module';
import { HistoryActiveModule } from './pages/admin/qrcode/batchstamp/historyActive/historyActive.module';
import { HistorySaleoutModule } from './pages/admin/qrcode/batchstamp/history-saleout/historySaleout.module';
import { LinkSaleoutModule } from './pages/admin/qrcode/batchstamp/linkSaleout/linkSaleout.modules';
import { IntegrateSelloutModule } from './pages/admin/qrcode/integrate-sellout/integrate-sellout.module';
import { IntegrateLoyaltyModule } from './pages/admin/qrcode/integrate-loyalty/integrate-loyalty.module';
import { LinkLoyaltyModule } from './pages/admin/qrcode/batchstamp/linkLoyalty/linkLoyalty.modules';
import { ImportCratingModule } from './pages/admin/qrcode/import-crating/import-crating.module';
import { FireBaseService } from './common/services/FireBase.service';
import { TrainingModule } from './pages/admin/qrcode/training/training.module';
import { IntegrateLoyaltyV2Module } from './pages/admin/qrcode/integrate-loyalty-v2/integrate-loyalty-v2.module';
import { LanguageInterceptor } from './common/services/LanguageInterceptor';

@NgModule({
  declarations: [AppAdminComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    StoreModule.provideStore(reducer),
    FlashMessagesModule,
    CustomFormsModule,
    WidthdrawalModule,
    DistributionModule,
    Distribution2Module,
    OrderModule,
    NotificationsModule,

    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule, // imports firebase/database, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features
    EffectsModule.run(AuthEffects),
    // Admin Module
    AppAdminRoutingModule,
    AuthenticateModule,
    LayoutModule,
    // Evs Module
    EvsProModule,
    ModalModule.forRoot(),
    EVSModule,

    // Anph 02/10/2017 import module QR Code
    BatchstampModule,
    CustomerModule,
    StatisticModule,
    StaticModule,
    StaticReportModule,
    GiftModule,
    ExchangeModule,
    BoxRetalStampsModule,
    RequestBoxModule,
    RequestBoxSendModule,
    ProductRoadmapModule,
    StampListMbModule,
    HistoryActiveModule,
    HistorySaleoutModule,
    LinkSaleoutModule,
    LinkLoyaltyModule,
    IntegrateSelloutModule,
    IntegrateLoyaltyModule,
    ImportCratingModule,
    TrainingModule,
    IntegrateLoyaltyV2Module,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AuthGuard,
    ApiService,
    ForgotPassBusinessService,
    AuthenticateService,
    ApiIcheckService,
    ConfirmPhoneGuard,
    PagerService,
    CategoryService,
    FireBaseService,
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    { provide: RequestOptions, useClass: DefaultRequestOptions }
  ],
  exports: [HistoryActiveModule],
  bootstrap: [AppAdminComponent],
})
export class AppAdminModule {
}



// WEBPACK FOOTER //
// /app/src/app/app-admin.module.ts